import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createBundle,
  updateBundle,
  deleteBundle,
} from "../../../../services/bundle";
import toast from "react-hot-toast";

function useAdminBundle() {
  const queryClient = useQueryClient();

  // Create bundle mutation
  const createBundleMutation = useMutation({
    mutationFn: (bundleData) => createBundle(bundleData),
    onSuccess: () => {
      queryClient.invalidateQueries(["adminBundles"]);
      toast.success("Bundle created successfully!");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.error || "Failed to create bundle");
    },
  });

  // Update bundle mutation
  const updateBundleMutation = useMutation({
    mutationFn: ({ bundleId, bundleData }) =>
      updateBundle(bundleId, bundleData),
    onSuccess: () => {
      queryClient.invalidateQueries(["adminBundles"]);
      toast.success("Bundle updated successfully!");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.error || "Failed to update bundle");
    },
  });

  // Delete bundle mutation
  const deleteBundleMutation = useMutation({
    mutationFn: (bundleId) => deleteBundle(bundleId),
    onSuccess: () => {
      queryClient.invalidateQueries(["adminBundles"]);
      toast.success("Bundle has been deleted!");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.error || "Failed to delete bundle");
    },
  });

  return {
    createBundle: createBundleMutation.mutate,
    isCreatingBundle: createBundleMutation.isLoading,
    createBundleStatus: createBundleMutation,
    updateBundle: updateBundleMutation.mutate,
    updateBundleStatus: updateBundleMutation,
    deleteBundle: deleteBundleMutation.mutate,
    deleteBundleStatus: deleteBundleMutation,
  };
}

export default useAdminBundle;
